import React, { useState, useEffect } from 'react';

const Home = () => {
  const slides = [
    {
      imageDesktop: './assets/imgs/1-desktop.jpg',
      imageMobile: './assets/imgs/1-mobile.png',
      heading: '',
      text1: '',
      text2: '',
    },
    {
      imageDesktop: './assets/imgs/UDC-5.jpg',
      imageMobile: './assets/imgs/UDC-5.jpg',
      heading: 'Moisture defense, Worldwide confidence',
      text1: 'Removes moisture from rooms, storage areas',
      text2: 'Prevents rust and corrosion',
    },
    {
      imageDesktop: './assets/imgs/UDC-8.jpg',
      imageMobile: './assets/imgs/UDC-8.jpg',
      heading: 'Moisture defense, Worldwide confidence',
      text1: 'Preserve food and extend shelf life of products',
      text2: 'Environment-friendly',
    },
    {
      imageDesktop: './assets/imgs/UDC-12.jpg',
      imageMobile: './assets/imgs/UDC-12.jpg',
      heading: 'Moisture defense, Worldwide confidence',
      text1: 'Prevent odors',
      text2: 'Prevent molds and mildew formation',
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Update `isMobile` state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check on mount

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000); // Change slides every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section
      id="home"
      className="w-full min-h-min lg:mt-40 bg-white flex justify-center items-center px-3"
    >
      {/* Slideshow Container */}
      <div className="w-full max-w-6xl overflow-hidden rounded-3xl shadow-lg relative">
        {/* Background Image */}
        <div
          className="w-full h-[800px] bg-cover bg-center transition-all duration-700 ease-in-out relative"
          style={{
            backgroundImage: `url(${
              isMobile
                ? slides[currentSlide].imageMobile
                : slides[currentSlide].imageDesktop
            })`,
          }}
        >
          <div className="h-full w-full bg-black bg-opacity-20 flex flex-col justify-center items-center text-center px-6 sm:px-12">
            {/* Heading */}
            <h1 className="text-4xl md:text-5xl font-bold text-white">
              {slides[currentSlide].heading}
            </h1>
            {/* Text Content */}
            <p className="mt-4 text-lg md:text-xl text-gray-200">
              {slides[currentSlide].text1}
            </p>
            <p className="text-lg md:text-xl text-gray-200">
              {slides[currentSlide].text2}
            </p>
          </div>
          {/* Slide Indicator with Number on Active Slide */}
          <div className="absolute bottom-6 left-0 right-0 flex space-x-4 items-center justify-center z-10">
            {slides.map((_, index) => (
              <div key={index} className="flex items-center space-x-2">
                {/* Line */}
                <div
                  className={`h-1 ${
                    index === currentSlide
                      ? 'bg-white w-24 sm:w-40'
                      : 'bg-gray-400 w-20 sm:w-36'
                  }`}
                ></div>

                {/* Conditionally render number only for the active slide */}
                {index === currentSlide && (
                  <span className="text-white text-lg sm:text-xl font-bold">{`0${
                    index + 1
                  }`}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
